/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Stat_HoldInputs */

const en_us2_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time held`)
};

const pt_br2_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo em isometria`)
};

const es_419_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo en isometría`)
};

const pt_pt2_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo em isometria`)
};

const fr_fr2_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de maintien`)
};

const de_de2_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haltezeit`)
};

const it_it2_workout_after_stat_hold = /** @type {(inputs: Workout_After_Stat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo in tenuta`)
};

/**
* | output |
* | --- |
* | "Time held" |
*
* @param {Workout_After_Stat_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_stat_hold = /** @type {((inputs?: Workout_After_Stat_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Stat_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_stat_hold(inputs)
	if (locale === "es-419") return es_419_workout_after_stat_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_stat_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_stat_hold(inputs)
	if (locale === "de-DE") return de_de2_workout_after_stat_hold(inputs)
	if (locale === "it-IT") return it_it2_workout_after_stat_hold(inputs)
	return en_us2_workout_after_stat_hold(inputs)
});
export { workout_after_stat_hold as "workout-after.stat_hold" }